export default __webpack_public_path__ + "static/media/Mark-3-HUD-Pop-Up (1 Layer).64614de3.jpg";